<template>
<div class="chapter">
<div class="inner_page">
<p class="EP"> </p>
<p class="EP"> </p>
<p class="EP">You could learn as much at the Hotel Florida in those years as you could learn anywhere in the world.</p>
<p class="EPC">—Ernest Hemingway</p>
<p class="EPV">Cómo se pasa la vida,</p>
<p class="EPV">Cómo se viene la muerte.</p>
<p class="EPV">Tan callando:</p>
<p class="EPV">Cuán presto se va el placer,</p>
<p class="EPV">Cómo, después de acordado,</p>
<p class="EPV">Da dolor,</p>
<p class="EPV">Cómo, a nuestro parecer,</p>
<p class="EPV">Cualquier tiempo pasado</p>
<p class="EPV">Fué mejor.</p>
<p class="EPC-L">—Jorge Manrique</p>
<p class="EP">For what is a man profited, if he shall gain the whole world, and lose his own soul?</p>
<p class="EPC">—Matthew 16:26</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?51f50ec6